import React from "react";
import excel from "../Images/excel.jpg";
import excel1 from "../Images/excel1.png";
import excelBackground from "../Images/excelbackground.png"


const ExcelSection = () => {
  return (
    <div className="bg-gray-50">

      {/* ================= HERO SECTION ================= */}

      {/* <section className="relative h-[420px] md:h-[500px] bg-gradient-to-r from-blue-50 via-white to-slate-100"> */}
       <section
              className="relative h-[420px] md:h-[500px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${excelBackground})`, // Replace with your AutoCAD blueprint image later
              }}
            >

        <div className="max-w-7xl mx-auto h-full px-6 lg:px-8 flex items-center">

          <div className="max-w-3xl">

            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-[2px] bg-amber-500"></div>

              <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
                Our Services
              </span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Excel Estimation
            </h1>

            <p className="mt-8 text-lg text-gray-600 leading-8">
              Professional Excel-based reinforcing steel quantity take-offs,
              material calculations, cost estimation and reporting using
              structured templates for maximum accuracy and efficiency.
            </p>

          </div>

        </div>

      </section>

      {/* ================= SERVICES ================= */}

      <section className="py-24 bg-white">

        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <div className="grid lg:grid-cols-2 gap-16">

            {/* Card 1 */}

            <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition">

              <img
                src={excel}
                alt="Smart Excel Templates"
                className="w-full h-72 object-cover"
              />

              <div className="p-8">

                <h2 className="text-3xl font-bold text-slate-900 mb-5">
                  Smart Excel Templates
                </h2>

                <p className="text-gray-600 leading-8">
                  Professionally designed Excel templates for
                  reinforcing steel quantity take-offs,
                  cost estimation,
                  project calculations,
                  productivity monitoring,
                  and material planning.
                </p>

                <ul className="mt-8 space-y-4">

                  {[
                    "Rebar Quantity Take-offs",
                    "Automatic Formula Calculations",
                    "Material Cost Estimation",
                    "Project Reporting",
                    "Custom Excel Formats",
                  ].map((item, index) => (

                    <li
                      key={index}
                      className="flex items-center gap-3"
                    >

                      <span className="w-7 h-7 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center font-bold">
                        ✓
                      </span>

                      {item}

                    </li>

                  ))}

                </ul>

              </div>

            </div>

            {/* Card 2 */}

            <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition">

              <img
                src={excel1}
                alt="Live Data Tracking"
                className="w-full h-72 object-cover"
              />

              <div className="p-8">

                <h2 className="text-3xl font-bold text-slate-900 mb-5">
                  Live Data Tracking
                </h2>

                <p className="text-gray-600 leading-8">
                  Dynamic Excel spreadsheets with advanced formulas,
                  automatic updates,
                  material summaries,
                  error checking,
                  and project monitoring to improve productivity.
                </p>

                <ul className="mt-8 space-y-4">

                  {[
                    "Live Quantity Updates",
                    "Formula Automation",
                    "Material Summary",
                    "Error Reduction",
                    "Client Reports",
                  ].map((item, index) => (

                    <li
                      key={index}
                      className="flex items-center gap-3"
                    >

                      <span className="w-7 h-7 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center font-bold">
                        ✓
                      </span>

                      {item}

                    </li>

                  ))}

                </ul>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ================= BENEFITS ================= */}

      <section className="py-24 bg-gray-50">

        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-16">

            <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
              Benefits
            </span>

            <h2 className="text-5xl font-bold text-slate-900 mt-4">
              Why Excel Estimation?
            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

            {[
              {
                title: "Fast Calculations",
                desc: "Automated formulas provide quick and accurate estimates.",
              },
              {
                title: "Error Reduction",
                desc: "Minimizes manual calculations and improves accuracy.",
              },
              {
                title: "Custom Reports",
                desc: "Generate client-ready reports in minutes.",
              },
              {
                title: "Easy Revisions",
                desc: "Update quantities instantly without starting over.",
              },
            ].map((card, index) => (

              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:-translate-y-2 transition"
              >

                <div className="w-14 h-14 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center text-2xl font-bold mb-6">
                  {index + 1}
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  {card.title}
                </h3>

                <p className="text-gray-600 leading-7">
                  {card.desc}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= CTA ================= */}

     
    </div>
  );
};

export default ExcelSection;